// extracted by mini-css-extract-plugin
export default {"feature":"Feature_feature__Jun9R"};